module.exports = __webpack_public_path__ + "static/img/anli2.829b775.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli/anli2.gif
// module id = Gv/U
// module chunks = 1